import * as _ from 'lodash';
import { User as UserClaims } from '../auth/me.lib';
import { formatText, isNotNull } from '../common/utils.lib';
import {
  docTypes,
  ItemModes,
  StoryLabels, StoryPoints, StoryPriorities, StoryStates, StoryTypes, UserStoryReviewStatus, UserStoryReviewTypes

} from '../common/constants.lib';
// import { isNotNull } from "@casi-ts/utils";

export function setDefaultStatus(statuses: CasiStoryStatus[] = [], defaultStr: string = 'Not Started'): CasiStoryStatus | undefined {
  if (statuses.length === 0) {
    throw new Error(`setDefaultStatus: expected array of statuses`);
  }
  return statuses.find(s => s.user_story_status_description.toLowerCase() === defaultStr.toLowerCase());
}

export interface IIdish {
  id: number
};

export interface IRole {
  id?: number,
  name?: string,
  permission_cnt?: string,
  can_select?: boolean
};

export class Role implements IRole {
  static create(args: any) {
    const {
      id, name, permission_cnt, can_select
    } = args;
    return new Role(id, name, permission_cnt, can_select);
  }
  constructor(
    public id?: number,
    public name?: string,
    public permission_cnt?: string,
    public can_select?: boolean
  ) {
    this.can_select = this.can_select || this.can_select === false ? this.can_select : true;
  }

  get permissionCnt(): number {
    if (this.permission_cnt)
      return +this.permission_cnt;
    return 0;
  }

  get canSelect(): string {
    return this.can_select ? 'Yes' : '';
  }
};

export interface IPermissionNew {
  entity?: string;
  action?: string;
};

export class PermissionNew implements IPermissionNew {
  static create() {
    return new PermissionNew();
    // return new PermissionNew('', '');
  }
  constructor(
    public entity?: string,
    public action?: string) { }

};

export interface IPermission extends IPermissionNew {
  id: number;
  selected?: boolean;
};

export class Permission implements IPermission {
  static create(args: IPermission) {
    const {
      id, entity, action
    } = args;
    return new Permission(id, entity, action);
  }

  constructor(
    public id: number,
    public entity?: string,
    public action?: string,
    public selected: boolean = false
  ) { }

  set select(val: boolean) {
    this.selected = val;
  }
  get select() {
    return this.selected;
  }

  getRolePermission(roleId: number): RolePermission | undefined {
    if (this.id)
      return new RolePermission(roleId, this.id);
    return undefined;
  }
};

export type PermissionType = PermissionNew | Permission;

export interface IUserDbNew {
  user_id: number;
  user?: string;
  project_id?: number;
  project_name?: string;
  database_name?: string;
  description?: string;
  no_updates_due?: number;
  host?: string;
  port?: number;
  use_ssh_tunnel?: boolean;
  tunnel_port?: number;
  tunnel_user_name?: string;
  tunnel_destination_host?: string;
};

export class UserDbNew implements IUserDbNew {
  static createNew(userId: number) {
    return new UserDbNew(userId);
  }
  constructor(
    public user_id: number,
    public project_id?: number,
    public database_name?: string,
    public description?: string,
    public no_updates_due?: number,
    public host?: string,
    public port?: number,
    public use_ssh_tunnel?: boolean,
    public tunnel_port?: number,
    public tunnel_user_name?: string,
    public tunnel_destination_host?: string,
    public user?: string,
    public project_name?: string
  ) { }
};

export interface IUserDb extends IUserDbNew {
  id: number;
};

export type UserDbType = IUserDbNew | IUserDb;

export class UserDb implements IUserDb {
  static create(args: IUserDb) {
    const { id, user_id, project_id, database_name,
      description, no_updates_due,
      host, port, use_ssh_tunnel,
      tunnel_port,
      tunnel_user_name,
      tunnel_destination_host,
      user, project_name
    } = args;
    return new UserDb(
      id,
      user_id,
      project_id,
      database_name,
      description,
      no_updates_due,
      host,
      port,
      use_ssh_tunnel,
      tunnel_port,
      tunnel_user_name,
      tunnel_destination_host,
      user, project_name
    )
  }
  static from(item: IUserDb, projects: Project[], users: User[]) {
    const { user_id, project_id,
    } = item;
    // console.log(`from:user_id: `, user_id);
    if (isNotNull(user_id) && users.length > 0) {
      let found = users.find(u => u.id === user_id);
      // console.log(`from:user:found: `, found);
      if (isNotNull(found)) {
        item.user = found?.email;
      }
    }
    if (isNotNull(project_id) && projects.length > 0) {
      let found = projects.find(p => p.id === project_id);
      if (isNotNull(found)) {
        item.project_name = found?.project_name;
      }
    }
    // console.log('from:item: ', item);
    return UserDb.create(item);
  }

  constructor(
    public id: number,
    public user_id: number,
    public project_id?: number,
    public database_name?: string,
    public description?: string,
    public no_updates_due?: number,
    public host?: string,
    public port?: number,
    public use_ssh_tunnel?: boolean,
    public tunnel_port?: number,
    public tunnel_user_name?: string,
    public tunnel_destination_host?: string,
    public user?: string,
    public project_name?: string
  ) {
  }
}

export interface IUserDbToProcess {
  id: number;
  implemention_order: number;
  project_id: number;
  file_name: string;
  update_script: string;
  updateScriptDisplay?: string | null;
  submission_email_address: string;
  description: string | null;
  selected: boolean | null;
  project_name?: string | null;
};

export class UserDbToProcess implements IUserDbToProcess {
  public updateScriptDisplay?: string | undefined | null;

  static create(args: IUserDbToProcess) {
    const {
      id, implemention_order,
      project_id, project_name,
      file_name, update_script,
      submission_email_address,
      description, selected
    } = args;

    return new UserDbToProcess(id,
      implemention_order, project_id,
      file_name, update_script, submission_email_address,
      description, selected,
      project_name
    );
  }

  static from(item: IUserDbToProcess, projects: Project[]) {
    const { project_id,
    } = item;
    if (isNotNull(project_id) && projects.length > 0) {
      let found = projects.find(p => p.id === project_id);
      if (isNotNull(found)) {
        item.project_name = found?.project_name;
      }
    }

    return UserDbToProcess.create(item);
  }

  constructor(
    public id: number,
    public implemention_order: number,
    public project_id: number,
    public file_name: string,
    public update_script: string,
    public submission_email_address: string,
    public description: string | null,
    public selected: boolean | null,
    public project_name?: string | null,
  ) {
    if (update_script && update_script.length > 30) {
      this.updateScriptDisplay = `${update_script.substring(0, 30)}...`;
    } else {
      this.updateScriptDisplay = update_script;
    }
    this.selected = true;
  }
};

export interface IDbUpdateNew {
  project_id: number;
  description?: string | null;
  file_name?: string | null;
  update_script?: string | null;
  updateScriptDisplay?: string | null;
  created_by_user_id?: number | null;
  approved_by_user_id?: number | null;
  approved_on: Date | null;
  approved_by_user?: string | null;
  implementation_order?: number | null;
  created_by_user?: string | null;
  project_name?: string | null;
};

export class DbUpdateNew implements IDbUpdateNew {
  public updateScriptDisplay?: string | undefined | null;

  static create(project: Project, user: UserClaims) {
    return new DbUpdateNew(
      project.id,
      null,
      null,
      null,
      user.userId,
      null,
      null,
      1,
      user.email,
      project.project_name,
      null
    );
  }
  constructor(
    public project_id: number,
    public description?: string | null,
    public file_name?: string | null,
    public update_script?: string | null,
    public created_by_user_id?: number | null,
    public approved_by_user_id?: number | null,
    public approved_on: Date | null = null,
    public implementation_order?: number | null,
    public created_by_user?: string | null,
    public project_name?: string | null,
    public approved_by_user?: string | null
  ) {
    if (update_script && update_script.length > 30) {
      this.updateScriptDisplay = `${update_script.substring(0, 30)}...`;
    } else {
      this.updateScriptDisplay = update_script;
    }
  }
};

export interface IDbUpdate extends IDbUpdateNew {
  id: number;
  isOwner?: boolean | null;
  wasAlreadyApproved?: boolean | null;
  isAdmin?: boolean | null;
  approvedOn?: string | null;
};

export type DbUpdateType = IDbUpdateNew | IDbUpdate;

export class DbUpdate implements IDbUpdate {
  public updateScriptDisplay?: string | undefined | null;

  static create(args: IDbUpdate) {
    const {
      id, project_id, description, file_name,
      update_script, created_by_user, created_by_user_id,
      approved_by_user, approved_by_user_id, approved_on,
      implementation_order, project_name,
      isOwner, wasAlreadyApproved, isAdmin,
      approvedOn
    } = args;
    return new DbUpdate(
      id,
      project_id,
      description,
      file_name,
      update_script,
      created_by_user_id,
      approved_by_user_id,
      approved_on ? new Date(approved_on) : approved_on,
      implementation_order,
      isOwner,
      wasAlreadyApproved,
      isAdmin,
      approvedOn,
      created_by_user,
      approved_by_user,
      project_name
    );
  }

  static from(item: IDbUpdate, projects: Project[], users: User[], me: UserClaims) {
    const { project_id, created_by_user_id, approved_by_user_id } = item;
    const { userId, admin } = me;
    if (isNotNull(project_id) && projects.length > 0) {
      let found = projects.find(p => p.id === project_id);
      if (isNotNull(found)) {
        item.project_name = found!.project_name;
      }
    }
    if (isNotNull(created_by_user_id) && users.length > 0) {
      let found = users.find(u => u.id === created_by_user_id);
      if (isNotNull(found)) {
        item.created_by_user = found!.email;
      }
    }
    if (isNotNull(approved_by_user_id) && users.length > 0) {
      let found = users.find(u => u.id === approved_by_user_id);
      if (isNotNull(found)) {
        item.approved_by_user = found!.email;
      }
    }
    // console.log(`tmpUser`, item, item?.approved_on, typeof item?.approved_on);
    item.approvedOn = item.approved_on ? new Date(item?.approved_on).toLocaleDateString() : null; //.format('DD/MM/YYYY') : null;
    // item.approvedOn = item.approved_on ? item?.approved_on.toLocaleDateString() : null; //.format('DD/MM/YYYY') : null;
    item.wasAlreadyApproved = isNotNull(approved_by_user_id);
    item.isOwner = isNotNull(userId) ? userId === item.created_by_user_id : false;
    item.isAdmin = admin || false;
    return DbUpdate.create(item);
  }

  constructor(
    public id: number,
    public project_id: number,
    public description?: string | null,
    public file_name?: string | null,
    public update_script?: string | null,
    public created_by_user_id?: number | null,
    public approved_by_user_id?: number | null,
    public approved_on: Date | null = null,
    public implementation_order?: number | null,
    public isOwner?: boolean | null,
    public wasAlreadyApproved?: boolean | null,
    public isAdmin?: boolean | null,
    public approvedOn?: string | null,
    public created_by_user?: string | null,
    public approved_by_user?: string | null,
    public project_name?: string | null
  ) {
    if (update_script && update_script.length > 30) {
      this.updateScriptDisplay = `${update_script.substring(0, 30)}...`;
    } else {
      this.updateScriptDisplay = update_script;
    }
  }
};

export interface IUserDbUpdate {
  id: number;
  project_name?: string | null;
  contact_person?: string | null;
  contact_email?: string | null;
  database_name?: string | null;
  description?: string | null;
  file_name?: string | null;
  // update_script?: string | null;
  user_db_id?: number | null;
  db_update_id?: number | null;
  // updateScriptDisplay?: string | null;
};

export class UserDbUpdate implements IUserDbUpdate {
  // public updateScriptDisplay?: string | undefined | null;

  static create(args: IUserDbUpdate) {
    const {
      id,
      project_name,
      contact_person, contact_email,
      database_name, description,
      file_name, // update_script,
      user_db_id, db_update_id
    } = args;
    return new UserDbUpdate(
      id, project_name,
      contact_person, contact_email,
      database_name, description,
      file_name, // update_script,
      user_db_id, db_update_id
    );
  }

  constructor(
    public id: number,
    public project_name?: string | null,
    public contact_person?: string | null,
    public contact_email?: string | null,
    public database_name?: string | null,
    public description?: string | null,
    public file_name?: string | null,
    // public update_script?: string | null,
    public user_db_id?: number | null,
    public db_update_id?: number | null
  ) {
    // if (update_script && update_script.length > 30) {
    //   this.updateScriptDisplay = `${update_script.substring(0, 30)}...`;
    // } else {
    //   this.updateScriptDisplay = update_script;
    // }
  }
}

export interface IRolePermission {
  role_id: number,
  permission_id: number
};

export class RolePermission implements IRolePermission {
  static createFrom(role: Role, permission: Permission) {
    return new RolePermission((role.id as number), permission.id);
  }

  static create(args: any) {
    const { role_id, permission_id } = args;
    return new RolePermission(
      role_id,
      permission_id
    );
  }

  constructor(
    public role_id: number,
    public permission_id: number
  ) { }
}

export class RolePermissionSelectable {
  constructor() { }
}

export interface IUser {
  id?: number;
  first_name?: string;
  last_name?: string;
  phone?: string;
  email?: string;
  research_consent?: boolean;
  accepted_terms_version?: number;
  userRoles?: any[];
  fullName?: string;
  initials?: string;
  active?: boolean;
  display_name?: string;
  newsletter?: boolean;
};

export class User implements IUser {
  static create(args: any) {
    const {
      id, first_name, last_name, phone,
      email, research_consent,
      accepted_terms_version, active, display_name, newsletter
    } = args;
    return new User(
      id,
      email, phone,
      first_name, last_name,
      research_consent, accepted_terms_version, active, display_name, newsletter
    );
  }

  public userRoles: any[] = [];
  // public fullName?: string;
  // public intitials?: string;
  public user_label: string;

  constructor(
    public id?: number,
    public email: string = '',
    public phone?: string,
    public first_name?: string,
    public last_name?: string,
    public research_consent?: boolean,
    public accepted_terms_version?: number,
    public active?: boolean,
    public display_name?: string,
    public newsletter?: boolean
  ) {
    this.userRoles = [];
    this.user_label = `${this.first_name} ${this.last_name} (${this.email})`;

  }

  get researchConsent(): string {
    return this.research_consent ? 'Yes' : '';
  }

  get newsletterVal(): string {
    return this.newsletter ? 'Yes' : '';
  }

  get fullName() {
    if (this.first_name && this.last_name) {
      return `${this.first_name} ${this.last_name}`;
    } else if (this.first_name) {
      return this.first_name;
    } else if (this.last_name) {
      return this.last_name
    } else {
      return `fullName not set`;
    }
  }

  get initials() {
    if (this.first_name && this.last_name) {
      return `${this.first_name.charAt(0).toUpperCase()}${this.last_name.charAt(0).toLocaleUpperCase()}`;
    } else if (this.first_name) {
      return this.first_name.charAt(0).toUpperCase();
    } else if (this.last_name) {
      return this.last_name.charAt(0).toLocaleUpperCase()
    } else {
      return `NS`;
    }
  }

  addRoles(roles: any[]) {
    this.userRoles = [...roles];
  }
};

export interface IUserRole {
  role_id: number
};

export class UserRole implements IUserRole {
  static create(args: any) {
    const { role_id } = args;
    return new UserRole(role_id);
  }
  constructor(
    public role_id: number
  ) { }
};

export interface MayHaveId {
  id?: number;
  checked?: boolean;
  description?: string;
}

export interface ICasiControl {
  db_major_version?: number;
  db_minor_version?: number;
  app_base_url?: string;
  param_company_name?: string;
  param_entity_name?: string;
  param_company_address?: string;
  param_abn?: string;
  param_acn?: string;
  param_primary_email?: string;
  param_additional_email?: string;
  param_website_url?: string;
  param_primary_contact_number?: number;
  param_additional_contact_number?: number;
  param_product_name?: string;
};

export interface ICasiControlImage {
  id?: number;
  param_primary_image?: string;
  param_additional_image?: string;
  param_reply_to_email?: string;
  param_reset_password_bcc?: string;
};

export class CasiControl implements ICasiControl {
  static create(args: any) {
    const {
      db_major_version, db_minor_version, app_base_url,
      param_company_name, param_entity_name,
      param_company_address, param_abn, param_acn,
      param_primary_email, param_additional_email,
      param_website_url, param_primary_contact_number,
      param_additional_contact_number, param_product_name
    } = args;
    return new CasiControl(
      db_major_version, db_minor_version, app_base_url,
      param_company_name, param_entity_name,
      param_company_address, param_abn, param_acn,
      param_primary_email, param_additional_email,
      param_website_url, param_primary_contact_number,
      param_additional_contact_number, param_product_name
    );
  }

  constructor(
    public db_major_version?: number,
    public db_minor_version?: number,
    public app_base_url?: string,
    public param_company_name?: string,
    public param_entity_name?: string,
    public param_company_address?: string,
    public param_abn?: string,
    public param_acn?: string,
    public param_primary_email?: string,
    public param_additional_email?: string,
    public param_website_url?: string,
    public param_primary_contact_number?: number,
    public param_additional_contact_number?: number,
    public param_product_name?: string
  ) {
  }
}

export class CasiControlWithParams implements ICasiControl, ICasiControlImage {
  static create(args: any) {
    const {
      id,
      db_major_version, db_minor_version, app_base_url,
      param_company_name, param_entity_name,
      param_company_address, param_abn, param_acn,
      param_primary_email, param_additional_email,
      param_website_url, param_primary_contact_number,
      param_additional_contact_number, param_product_name,
      param_primary_image, param_additional_image,
      param_reply_to_email, param_reset_password_bcc
    } = args;
    return new CasiControlWithParams(
      id,
      db_major_version, db_minor_version, app_base_url,
      param_company_name, param_entity_name,
      param_company_address, param_abn, param_acn,
      param_primary_email, param_additional_email,
      param_website_url, param_primary_contact_number,
      param_additional_contact_number, param_product_name,
      param_primary_image, param_additional_image,
      param_reply_to_email, param_reset_password_bcc
    );
  }

  constructor(
    public id?: number,
    public db_major_version?: number,
    public db_minor_version?: number,
    public app_base_url?: string,
    public param_company_name?: string,
    public param_entity_name?: string,
    public param_company_address?: string,
    public param_abn?: string,
    public param_acn?: string,
    public param_primary_email?: string,
    public param_additional_email?: string,
    public param_website_url?: string,
    public param_primary_contact_number?: number,
    public param_additional_contact_number?: number,
    public param_product_name?: string,
    public param_primary_image?: string,
    public param_additional_image?: string,
    public param_reply_to_email?: string,
    public param_reset_password_bcc?: string
  ) {
  }
}

export interface IControlHost {
  db_major_version?: number;
  db_minor_version?: number;
  app_base_url?: string;
  param_company_name?: string,
  param_entity_name?: string;
  param_company_address?: string;
  param_abn?: string;
  param_acn?: string;
  param_primary_email?: string;
  param_additional_email?: string;
  param_website_url?: string;
  param_primary_contact_number?: string;
  param_additional_contact_number?: string;
  param_product_name?: string
};

export class ControlHost implements IControlHost {
  static create(args: any) {
    const {
      db_major_version, db_minor_version, app_base_url,
      param_company_name, param_entity_name,
      param_company_address,
      param_abn, param_acn,
      param_primary_email,
      param_additional_email,
      param_website_url,
      param_primary_contact_number,
      param_additional_contact_number,
      param_product_name
    } = args;
    return new ControlHost(
      db_major_version, db_minor_version, app_base_url,
      param_company_name, param_entity_name, param_company_address,
      param_abn, param_acn,
      param_primary_email,
      param_additional_email,
      param_website_url,
      param_primary_contact_number,
      param_additional_contact_number,
      param_product_name
    );
  }


  constructor(
    public db_major_version?: number,
    public db_minor_version?: number,
    public app_base_url?: string,
    public param_company_name?: string,
    public param_entity_name?: string,
    public param_company_address?: string,
    public param_abn?: string,
    public param_acn?: string,
    public param_primary_email?: string,
    public param_additional_email?: string,
    public param_website_url?: string,
    public param_primary_contact_number?: string,
    public param_additional_contact_number?: string,
    public param_product_name?: string
  ) {
  }

};

export interface ILevelDropDownTree {
  text: string;
  items: any[]
};

export class LevelDropDownTree implements ILevelDropDownTree {
  constructor(
    public text: string,
    public items: any[],
    public id: number | null
  ) { }
};

export interface IProjectNew {
  project_name?: string;
  contact_person?: string;
  contact_email?: string;
  contact_telephone?: string;
  funding_body?: string;
  project_amount?: number;
  development_amount?: number;
  dev_url?: string;
  uat_url?: string;
  prod_url?: string;
  postgresql_ver?: string;
};

export interface IProject extends IProjectNew {
  id: number;
};

export type ProjectType = IProjectNew | IProject;

export interface IProjectFromWeb {
  id: number;
  project_name?: string;
  contact_person?: string;
  contact_email?: string;
  contact_telephone?: string;
  funding_body?: string;
  project_amount?: string;
  development_amount?: string;
  dev_url?: string;
  uat_url?: string;
  prod_url?: string;
  postgresql_ver?: string;
  active_user_stories?: boolean;
  active_db_manager?: boolean;
};

export class ProjectNew implements IProjectNew {
  constructor(
    public project_name?: string,
    public contact_person?: string,
    public contact_email?: string,
    public contact_telephone?: string,
    public funding_body?: string,
    public project_amount?: number,
    public development_amount?: number,
    public dev_url?: string,
    public uat_url?: string,
    public prod_url?: string,
    public postgresql_ver?: string,
  ) { }
};

export class Project implements IProject {

  static create(args: IProjectFromWeb) {
    const {
      id, project_name,
      contact_email, contact_person, contact_telephone,
      funding_body,
      project_amount,
      development_amount,
      dev_url, uat_url, prod_url,
      postgresql_ver,
      active_user_stories,
      active_db_manager
    } = args;

    return new Project(id,
      project_name,
      contact_person,
      contact_email,
      contact_telephone,
      funding_body,
      project_amount ? +project_amount : undefined,
      development_amount ? +development_amount : undefined,
      dev_url,
      uat_url,
      prod_url,
      postgresql_ver,
      active_user_stories,
      active_db_manager
    )
  }

  constructor(
    public id: number,
    public project_name?: string,
    public contact_person?: string,
    public contact_email?: string,
    public contact_telephone?: string,
    public funding_body?: string,
    public project_amount?: number,
    public development_amount?: number,
    public dev_url?: string,
    public uat_url?: string,
    public prod_url?: string,
    public postgresql_ver?: string,
    public active_user_stories?: boolean,
    public active_db_manager?: boolean
  ) { }

  // constructor(args: Partial<Project | undefined>) {
  //   if (args) {
  //     Object.assign(this, args);
  //   }
  // }
};

export interface IPostDbUpdate {
  username: string;
  password: string;
  database: string;
  host: string;
  port: number;
  sqlScript: string;
  tunnelUsername?: string | null;
  tunnelUserPw?: string | null;
  tunnelDbUsername?: string | null;
  tunnelDbPw?: string | null;
  tunnel_port?: number | null;
  tunnel_user_name?: string | null;
  use_ssh_tunnel?: boolean | null;
  tunnel_destination_host?: string | null;
};

export interface IDbMeta {
  dbUser: string;
  dbUserPw: string;
  tunnelUserPw?: string | null;
  tunnelUsername?: string | null;
  tunnelDbPw?: string | null;
  tunnelDbUsername?: string | null;
}

export class DbMeta implements IDbMeta {

  constructor(
    public dbUser: string,
    public dbUserPw: string,
    public tunnelUserPw?: string | null,
    public tunnelUsername?: string | null,
    public tunnelDbPw?: string | null,
    public tunnelDbUsername?: string | null
  ) {

  }

}

export class PostDbUpdate implements IPostDbUpdate {

  static create(userDb: UserDb, updateMeta: UserDbToProcess, dbMeta: IDbMeta) {
    const { database_name, host, port, tunnel_port,
      tunnel_user_name, use_ssh_tunnel, tunnel_destination_host } = userDb;
    const { update_script } = updateMeta;
    const { dbUser, dbUserPw, tunnelUserPw, tunnelUsername, tunnelDbPw, tunnelDbUsername } = dbMeta;

    return new PostDbUpdate(
      dbUser,
      dbUserPw,
      database_name!,
      host!,
      port!,
      update_script,
      tunnelUsername,
      tunnelUserPw,
      tunnelDbUsername,
      tunnelDbPw,
      tunnel_port,
      tunnel_user_name,
      use_ssh_tunnel,
      tunnel_destination_host
    )
  }

  constructor(
    public username: string,
    public password: string,
    public database: string,
    public host: string,
    public port: number,
    public sqlScript: string,
    public tunnelUsername?: string | null,
    public tunnelUserPw?: string | null,
    public tunnelDbUsername?: string | null,
    public tunnelDbPw?: string | null,
    public tunnel_port?: number | null,
    public tunnel_user_name?: string | null,
    public use_ssh_tunnel?: boolean | null,
    public tunnel_destination_host?: string | null,
  ) { }
};

export interface IControlParams {
  db_major_version: number;
  db_minor_version: number;
  send_payment_notification?: boolean | null;
  app_base_url?: string | null;
  use_live_payment_portal?: boolean | null;
  param_company_name?: string | null;
  param_entity_name?: string | null;
  param_company_address?: string | null;
  param_abn?: string | null;
  param_acn?: string | null;
  param_primary_email?: string | null;
  param_additional_email?: string | null;
  param_website_url?: string | null;
  param_primary_contact_number?: string | null;
  param_additional_contact_number?: string | null;
  param_primary_image?: string | null;
  param_additional_image?: string | null;
  param_product_name?: string | null;
  param_reply_to_email?: string | null;
  param_reset_password_bcc?: string | null;
  param_text_api_host?: string | null;
  param_text_api_port?: number | null;
  param_text_api_path?: string | null;
  param_text_api_user?: string | null;
  param_text_api_key?: string | null;
};

export class ControlParams implements IControlParams {

  static create(args: IControlParams) {
    const {
      db_major_version, db_minor_version,
      send_payment_notification,
      app_base_url,
      use_live_payment_portal,
      param_company_name, param_entity_name,
      param_company_address,
      param_abn, param_acn,
      param_primary_email,
      param_additional_email,
      param_website_url,
      param_primary_contact_number,
      param_additional_contact_number,
      param_primary_image,
      param_additional_image,
      param_product_name,
      param_reply_to_email,
      param_reset_password_bcc,
      param_text_api_host,
      param_text_api_port,
      param_text_api_path,
      param_text_api_user,
      param_text_api_key
    } = args;

    return new ControlParams(
      db_major_version,
      db_minor_version,
      send_payment_notification,
      app_base_url,
      use_live_payment_portal,
      param_company_name, param_entity_name,
      param_company_address,
      param_abn, param_acn,
      param_primary_email,
      param_additional_email,
      param_website_url,
      param_primary_contact_number,
      param_additional_contact_number,
      param_primary_image,
      param_additional_image,
      param_product_name,
      param_reply_to_email,
      param_reset_password_bcc,
      param_text_api_host,
      param_text_api_port,
      param_text_api_path,
      param_text_api_user,
      param_text_api_key
    );

  }

  constructor(
    public db_major_version: number,
    public db_minor_version: number,
    public send_payment_notification?: boolean | null,
    public app_base_url?: string | null,
    public use_live_payment_portal?: boolean | null,
    public param_company_name?: string | null,
    public param_entity_name?: string | null,
    public param_company_address?: string | null,
    public param_abn?: string | null,
    public param_acn?: string | null,
    public param_primary_email?: string | null,
    public param_additional_email?: string | null,
    public param_website_url?: string | null,
    public param_primary_contact_number?: string | null,
    public param_additional_contact_number?: string | null,
    public param_primary_image?: string | null,
    public param_additional_image?: string | null,
    public param_product_name?: string | null,
    public param_reply_to_email?: string | null,
    public param_reset_password_bcc?: string | null,
    public param_text_api_host?: string | null,
    public param_text_api_port?: number | null,
    public param_text_api_path?: string | null,
    public param_text_api_user?: string | null,
    public param_text_api_key?: string | null,

  ) { }

}

/**
 * Copied from Kendo-svg-icons SVGIcon
 */
export interface ITrackerSVGIcon {
  /**
   * The unique name of the icon.
   */
  name: string;
  /**
   * The entire SVG content of the icon.
   */
  content: string;
  /**
   * The [viewBox](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/viewBox)
   * definition that should be used for the icon.
   */
  viewBox: string;
}

export interface IStoryType {
  name: StoryTypes;
  icon: string; //IconName; // ITrackerSVGIcon
  iconClass: string;
}

export class StoryType implements IStoryType {

  constructor(
    public name: StoryTypes,
    public icon: string, //IconName, // string, // ITrackerSVGIcon
    public iconClass: string
  ) { }
}

export const storyTypeFactory = (): StoryType[] => {
  return [
    new StoryType(StoryTypes.Bug, 'bug', 'fa-bug'),
    new StoryType(StoryTypes.Feature, 'star', 'fa-star'),
    new StoryType(StoryTypes.Chore, 'gear', 'fa-gear'),
    new StoryType(StoryTypes.Release, 'flag-checkered', 'fa-checkered-flag')
  ]
};

export const defaultStoryTypes = storyTypeFactory();

export interface ICasiStoryType {
  id: number;
  user_story_type_description: string;
  icon?: string; //IconName; // ITrackerSVGIcon
  iconClass?: string;
}

export class CasiStoryType implements ICasiStoryType {
  id: number = 0;
  user_story_type_description: string = 'Not Set';
  icon?: string | undefined;
  iconClass?: string | undefined;
  // static create(partial: Partial<CasiStoryType>) {
  //   const { id, user_story_type_description } = partial;
  //   return new CasiStoryType(id!, user_story_type_description!);
  // }

  // constructor(
  //   public id: number,
  //   public user_story_type_description: string
  // ) { }
  constructor(partial: Partial<CasiStoryType>) {
    Object.assign(this, partial);
    let found = defaultStoryTypes.find((st) => st.name === this.user_story_type_description);
    if (found) {
      this.icon = found.icon;
      this.iconClass = found.iconClass;
    }
  }
}

export interface IStoryState {
  name: StoryStates;
}

export class StoryState implements IStoryState {
  constructor(public name: StoryStates) { }
}

export interface ICasiStoryStatusBase {
  id: number;
  user_story_status_description: string;
};

export interface ICasiStoryStatusOptions {
  nextUserStoryId: number;
  userStoryAction: string;
}
export interface ICasiStoryStatus extends ICasiStoryStatusBase {
  // id: number;
  // user_story_status_description: string;
  next_options: ICasiStoryStatusOptions[];
}
export interface ICasiStoryStatusParcel {
  original: ICasiStoryStatusBase;
  next_options: ICasiStoryStatusOptions
}

export class CasiStoryStatusParcel implements ICasiStoryStatusParcel {
  // original: ICasiStoryStatusBase;
  // next_options: ICasiStoryStatusOptions;

  constructor(public original: ICasiStoryStatusBase, public next_options: ICasiStoryStatusOptions) {
    // this.original = original;
    // this.next_options = next_options;
  }
}

export class CasiStoryStatus implements ICasiStoryStatus {
  static create(partial: Partial<CasiStoryStatus>) {
    const { id, user_story_status_description, next_options } = partial;
    return new CasiStoryStatus(id!, user_story_status_description!, next_options!);
  }

  constructor(
    public id: number,
    public user_story_status_description: string,
    public next_options: ICasiStoryStatusOptions[]
  ) { }
}

export interface IStoryPriority {
  name: StoryPriorities;
  // description: string;
}

export interface IStoryPoint {
  name: StoryPoints;
  icon?: ITrackerSVGIcon
};

export interface ICasiStoryPriority {
  id: number;
  user_story_priority_description: string;
}

export class CasiStoryPriority implements ICasiStoryPriority {
  static create(partial: Partial<CasiStoryPriority>) {
    const { id, user_story_priority_description } = partial;
    return new CasiStoryPriority(id!, user_story_priority_description!);
  }

  constructor(
    public id: number,
    public user_story_priority_description: string
  ) { }
}

export interface ICasiStoryEstimate {
  id: number;
  user_story_estimate_description: string;
}

export class CasiStoryEstimate implements ICasiStoryEstimate {
  static create(partial: Partial<CasiStoryEstimate>) {
    const { id, user_story_estimate_description } = partial;
    return new CasiStoryEstimate(id!, user_story_estimate_description!);
  }

  constructor(
    public id: number,
    public user_story_estimate_description: string
  ) { }
}

export interface ICasiProjectLabel {
  project_id: number;
  id?: number;
  project_label_description?: string;
  active?: boolean
}

export class CasiProjectLabel implements ICasiProjectLabel {
  static create(partial: Partial<CasiProjectLabel>) {
    const {
      project_id, id, project_label_description, active
    } = partial;
    return new CasiProjectLabel(project_id!, id, project_label_description, active);
  }

  constructor(
    public project_id: number,
    public id?: number,
    public project_label_description: string = '',
    public active?: boolean
  ) { }
}

export interface ICasiProjectUser {
  id?: number;
  project_id?: number;
  project_name?: string;
  user_id?: number;
  active?: boolean | null;
  first_name?: string;
  last_name?: string;
  email?: string;
  selected: boolean;
  fullName?: string;
  initials?: string;
}

export class CasiProjectUser implements ICasiProjectUser {
  static createFromUserAndProject(user: User, project: Project) {
    return new CasiProjectUser({
      project_id: project.id,
      user_id: user.id,
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email
    });
  }

  id?: number;
  project_id?: number;
  project_name?: string;
  user_id?: number;
  active?: boolean | null;
  first_name?: string;
  last_name?: string;
  email?: string;
  selected: boolean = false;

  constructor(partial: Partial<CasiProjectUser>) {
    Object.assign(this, partial);
  }

  get fullName() {
    if (this.first_name && this.last_name) {
      return `${this.first_name} ${this.last_name}`;
    } else if (this.first_name) {
      return this.first_name;
    } else if (this.last_name) {
      return this.last_name
    } else {
      return `fullName not set`;
    }
  }

  get initials() {
    if (this.first_name && this.last_name) {
      return `${this.first_name.charAt(0).toUpperCase()}${this.last_name.charAt(0).toLocaleUpperCase()}`;
    } else if (this.first_name) {
      return this.first_name.charAt(0).toUpperCase();
    } else if (this.last_name) {
      return this.last_name.charAt(0).toLocaleUpperCase()
    } else {
      return `NS`;
    }
  }


}

export class StoryPoint implements IStoryPoint {
  constructor(
    public name: StoryPoints,
    public icon?: ITrackerSVGIcon
  ) { }
}

export class StoryPriority implements IStoryPriority {
  constructor(
    public name: StoryPriorities,
    // public description: string
  ) { }
}

export interface IStoryLabel {
  name: StoryLabels,
  icon?: ITrackerSVGIcon
}

export class StoryLabel implements IStoryLabel {
  constructor(
    public name: StoryLabels,
    public icon?: ITrackerSVGIcon
  ) { }
}

export interface IUserStoryReview {
  name: UserStoryReviewTypes;
  reviewer?: number;
  status?: UserStoryReviewStatus;
}

export class UserStoryReview implements IUserStoryReview {
  constructor(
    public name: UserStoryReviewTypes,
    public reviewer?: number,
    public status?: UserStoryReviewStatus
  ) { }

}

export interface IUserStoryActivity {
  id: number;
  userStoryId: number;
  userId: number;
  description: string;
  userStoryActivityId?: number;
  attachments?: any[];
  dateTime?: Date;
  emoji?: any
};

export class UserStoryActivity implements IUserStoryActivity {
  id: number = 1;
  userStoryId: number = 1;
  userId: number = -7;
  description: string = 'Not set';
  userStoryActivityId?: number | undefined;
  attachments?: any[] | undefined;
  dateTime?: Date | undefined;
  emoji?: any | undefined;
  // constructor(
  //   public id: number,
  //   public userStoryId: number,
  //   public description: string,
  //   public userStoryActivityId?: number,
  //   public attachments?: any[]
  // ) {}
  constructor(partial: Partial<UserStoryActivity>) {
    Object.assign(this, partial);
  }
}

export interface IUserStory {
  id: number;
  projectId: number;
  title?: string;
  storyType?: StoryTypes;
  storyState?: StoryStates;
  storyPriority?: StoryPriorities;
  points?: IStoryPoint;
  requester: number;
  owners: number[];
  followThisStory?: string[];
  description?: string;
  lables?: IStoryLabel[];
  code?: string;
  tasks?: string[]
  activities?: IUserStoryActivity[]
}

export class UserStory implements IUserStory {

  id: number = 1;
  projectId: number = 1;
  title?: string;
  storyType?: StoryTypes;
  storyState?: StoryStates;
  storyPriority?: StoryPriorities;
  points?: IStoryPoint;
  requester: number = 1;
  owners: number[] = [];
  followThisStory?: string[];
  description?: string;
  lables?: IStoryLabel[];
  code?: string;
  tasks?: string[];
  activities?: IUserStoryActivity[];

  // constructor(
  //   public id: string,
  //   public projectId: number,
  //   public title?: string,
  //   public storyType?: string,
  //   public storyPriority?:string,
  //   public points?: string,
  //   public requester?:string,
  //   public owners?: string [],
  //   public followThisStory?: string [],
  //   public description?:string,
  //   public lables?: string[],
  //   public code?:string,
  //   public tasks?:string[]
  // ){}
  constructor(partial: Partial<UserStory>) {
    Object.assign(this, partial);
  }
};

export interface ICasiOwner {
  user_id: number;
  user_name: string;
  user_story_owner_id?: number
};

export class CasiOwner implements ICasiOwner {
  user_id: number = 1;
  user_name: string = '';
  user_story_owner_id?: number | undefined;

  constructor(partial: Partial<CasiOwner>) {
    Object.assign(this, partial);
  }
}

export interface ICasiUserStory {
  id?: number;
  project_id?: number;
  project_name?: string;
  title?: string;
  project_label_id?: number;
  project_label_description?: string;
  user_story_type_id?: number;
  user_story_type_description?: string;
  user_story_estimate_id?: number;
  user_story_estimate_description?: string;
  user_story_priority_id?: number;
  user_story_priority_description?: string;
  user_story_status_id?: number;
  user_story_status_description?: string;
  accepted_at?: Date;
  deadline?: Date;
  requested_by_user_id?: number;
  requested_by_user?: string;
  description?: string;
  updated_by_user_id?: number;
  updated_by_user?: string;
  owned_by_users_json?: ICasiOwner[];
  owned_by_users?: string;
  owned_by_user_ids?: number[];
  overrideUserIds: boolean;
  updatedAt?: Date;
  itemMode: ItemModes;
  sort_order?: number;
  previous_id?: number;
  next_id?: number;
}

export class CasiUserStory implements ICasiUserStory {

  static createWithDefaults(user?: User, project?: Project,
    storyStatus?: CasiStoryStatus[],
    storyTypes?: CasiStoryType[], storyPriorities?: CasiStoryPriority[],
    storyEstimates?: CasiStoryEstimate[]
  ) {
    let defaultStatus = setDefaultStatus(storyStatus)
    return new CasiUserStory({
      requested_by_user_id: user?.id || undefined,
      project_id: project?.id || undefined,
      project_name: project?.project_name || undefined,
      user_story_type_id: storyTypes ? storyTypes[2].id : undefined,
      user_story_estimate_id: storyEstimates ? storyEstimates[0].id : undefined,
      user_story_priority_id: storyPriorities ? storyPriorities[0].id : undefined,
      user_story_status_id: defaultStatus ? defaultStatus.id : undefined // storyStatus ? storyStatus[7].id : undefined
    })
  }

  id?: number;
  project_id?: number;
  project_name?: string;
  title?: string;
  project_label_id?: number;
  project_label_description?: string;
  user_story_type_id?: number;
  user_story_type_description?: string;
  user_story_estimate_id?: number;
  user_story_estimate_description?: string;
  user_story_priority_id?: number;
  user_story_priority_description?: string;
  user_story_status_id?: number;
  user_story_status_description?: string;
  accepted_at?: Date;
  deadline?: Date;
  requested_by_user_id?: number;
  requested_by_user?: string;
  description?: string;
  updated_by_user_id?: number;
  updated_by_user?: string;
  owned_by_users_json?: ICasiOwner[];
  owned_by_users?: string;
  owned_by_user_ids?: number[] = [];
  overrideUserIds: boolean = false;
  updatedAt?: Date;
  itemMode: ItemModes = ItemModes.UPDATE;
  sort_order?: number;
  previous_id?: number;
  next_id?: number;

  constructor(partial: Partial<CasiUserStory>) {
    Object.assign(this, partial);
    if (!this.overrideUserIds &&
      this.owned_by_users_json &&
      this.owned_by_users_json?.length > 0 &&
      this.owned_by_user_ids?.length === 0) {
      this.owned_by_user_ids = this.owned_by_users_json.map(o => o.user_id);
    }
    if (this.description)
      this.description = formatText(this.description);
    if (this.updatedAt) {
      this.updatedAt = new Date(this.updatedAt);
      // console.log(`type of updated At: `, typeof this.updatedAt);
    }
  }
};

export interface ICasiUserStoryComment {
  id?: number;
  user_story_id: number;
  user_id: number;
  first_name?: string;
  last_name?: string;
  comment?: string;
  createdAt?: Date;
  updatedAt?: Date;
};

export class CasiUserStoryComment implements ICasiUserStoryComment {
  id: number | undefined;
  user_story_id: number = 1;
  user_id: number = 1;
  first_name?: string | undefined;
  last_name?: string | undefined;
  comment?: string | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;

  constructor(partial: Partial<CasiUserStoryComment>) {
    Object.assign(this, partial);
    if (this.comment)
      this.comment = formatText(this.comment);
  }

};

export enum DashboardStrings {
  ICEBOX = 'Icebox',
  CURRENT = 'Current',
  COMPLETED = 'Completed',
  DELETED = 'Deleted'
};

export interface IUserStoryOptions {
  dashboardStr?: DashboardStrings | null;
  projectId?: number | null;
  projectLabelId?: number | null;
  userStoryTypeId?: number | null;
  userStoryEstimate?: number | null;
  userStoryPriorityId?: number | null;
  requestedByUserId?: number | null;
  ownedByUserId?: number | null;
}

export class UserStoryOptions implements IUserStoryOptions {
  dashboardStr: DashboardStrings | null | undefined = null;
  projectId: number | null | undefined = null;
  projectLabelId: number | null | undefined = null;
  userStoryTypeId: number | null | undefined = null;
  userStoryEstimate: number | null | undefined = null;
  userStoryPriorityId: number | null | undefined = null;
  requestedByUserId: number | null | undefined = null;
  ownedByUserId: number | null | undefined = null;

  constructor(partial: Partial<UserStoryOptions>) {
    Object.assign(this, partial);
  }
};

export interface ICasiOwnerUser {
  user_id: number;
  fullName?: string;
  initials?: string;
}

export class CasiOwnerUser implements ICasiOwnerUser {
  user_id: number = 0;
  fullName?: string;
  initials?: string;

  static createFromUser(args: User) {
    return new CasiOwnerUser({
      user_id: args.id,
      fullName: args.fullName,
      initials: args.initials
    });
  }

  static createFromProjectUser(args: CasiProjectUser) {
    return new CasiOwnerUser({
      user_id: args.user_id,
      fullName: args.fullName,
      initials: args.initials
    });
  }
  constructor(partial: Partial<CasiOwnerUser>) {
    Object.assign(this, partial);
  }

}

export interface IRelease {
  id?: number,
  project_id?: number
  project_name?: string,
  released_by_user?: string,
  released_by_user_id?: number,
  release_date?: Date,
  comment?: string
};

export class Release implements IRelease {
  static create(args: any) {
    const {
      id, project_id, project_name, released_by_user,
      released_by_user_id, release_date, comment
    } = args;
    return new Release(id, project_id, project_name, released_by_user,
      released_by_user_id, release_date, comment);
  }
  constructor(
    public id?: number,
    public project_id?: number,
    public project_name?: string,
    public released_by_user?: string,
    public released_by_user_id?: number,
    public release_date?: Date,
    public comment?: string
  ) {
  }

};

export interface IProjectSummary {
  no_releases?: string,
  no_stories_released?: string,
  project_name?: string,
  project_id?: number,
  no_stories_accepted?: string,
  no_stories_delivered?: string,
  no_stories_finished?: string,
  no_stories_rejected?: string,
  no_stories_started?: string,
  no_unstarted?: string,
  no_stories_unscheduled?: string,
  no_deleted?: string
}

export class ProjectSummary implements IProjectSummary {
  static create(args: any) {
    const {
      no_releases, no_stories_released, project_name, project_id, no_stories_accepted, no_stories_delivered,
      no_stories_finished, no_stories_rejected, no_stories_started, no_unstarted,
      no_stories_unscheduled, no_deleted
    } = args;
    return new ProjectSummary(no_releases, no_stories_released, project_name, project_id, no_stories_accepted, no_stories_delivered,
      no_stories_finished, no_stories_rejected, no_stories_started, no_unstarted,
      no_stories_unscheduled, no_deleted);
  }
  constructor(
    public no_releases?: string,
    public no_stories_released?: string,
    public project_name?: string,
    public project_id?: number,
    public no_stories_accepted?: string,
    public no_stories_delivered?: string,
    public no_stories_finished?: string,
    public no_stories_rejected?: string,
    public no_stories_started?: string,
    public no_unstarted?: string,
    public no_stories_unscheduled?: string,
    public no_deleted?: string
  ) {
  }

};

export interface IEnquiry {
  id: number,
  first_name?: string,
  last_name?: string,
  email: string,
  phone?: string,
  subject?: string,
  message?: string,
  completed: boolean,
  user_id: number,
  createdAt: string
};

export class Enquiry implements IEnquiry {
  static create(args: any) {
    const {
      id, first_name, last_name,
      email, phone,
      subject, message, completed,
      user_id, createdAt
    } = args;
    return new Enquiry(
      id, email, completed, user_id,
      createdAt,
      first_name, last_name,
      phone, subject,
      message
    );
  }

  constructor(
    public id: number,
    public email: string,
    public completed: boolean,
    public user_id: number,
    public createdAt: string,
    public first_name?: string,
    public last_name?: string,
    public phone?: string,
    public subject?: string,
    public message?: string
  ) {
  }
};

export interface IEnquiryAddress {
  id?: number,
  address?: string,
};

export class EnquiryAddress implements IEnquiryAddress {
  static create(args: any) {
    const {
      id, address
    } = args;
    return new EnquiryAddress(
      id, address
    );
  }

  constructor(
    public id?: number,
    public address?: string
  ) { }
};

//#region Discipline
export type DisciplineType = DisciplineNew | Discipline;

export interface IDiscipline {
  id: number,
  discipline_name?: string,
  active: boolean,
  no_subscales: number
};

export class Discipline implements IDiscipline {
  static create(args: any) {
    const { id, discipline_name, active, no_subscales } = args;
    return new Discipline(id, discipline_name, active, no_subscales);
  }

  constructor(
    public id: number,
    public discipline_name: string,
    public active: boolean,
    public no_subscales: number
  ) {
  }
};

export interface IDisciplineNew {
  discipline_name?: string,
  active: boolean
};

export class DisciplineNew implements IDisciplineNew {
  static create() {
    return new DisciplineNew();
  }
  constructor(
    public discipline_name?: string,
    public active = true
  ) { }

};
//#endregion

//#region DisciplineSubscale
export type DisciplineSubscaleType = DisciplineSubscaleNew | DisciplineSubscale;

export interface IDisciplineSubscale {
  id: number,
  discipline_id: number,
  subscale_description?: string,
  active: boolean,
  sort_order?: number
};

export class DisciplineSubscale implements IDisciplineSubscale {
  static create(args: any) {
    const { id, discipline_id, subscale_description, active, sort_order } = args;
    return new DisciplineSubscale(id, discipline_id, subscale_description, active, sort_order);
  }

  constructor(
    public id: number,
    public discipline_id: number,
    public subscale_description: string,
    public active: boolean,
    public sort_order: number
  ) {
  }
};

export interface IDisciplineSubscaleNew {
  discipline_id?: number,
  subscale_description?: string,
  active: boolean
};

export class DisciplineSubscaleNew implements IDisciplineSubscaleNew {
  static create(args: any) {
    const { id } = { ...args };
    return new DisciplineSubscaleNew(id);
  }
  constructor(
    public discipline_id?: number,
    public subscale_description?: string,
    public active = true
  ) { }

};
//#endregion

//#region Organisation
export type OrganisationType = OrganisationNew | Organisation;

export interface IOrganisation {
  id: number,
  organisation_name?: string,
  business_owner_name?: string,
  contact_email?: string,
  contact_telephone?: string,
  address?: string,
  // logo?: string,
  active?: boolean,
  no_users?: number,
  no_disciplines?: number,
  logo?: string,
  student_email_template?: string,
  supervisor_email_template?: string
};

export class Organisation implements IOrganisation {
  static create(args: any) {
    const { id, organisation_name, business_owner_name, contact_email, contact_telephone, address,
      active, no_users, no_disciplines, logo, student_email_template, supervisor_email_template } = args;
    return new Organisation(id, organisation_name, business_owner_name, contact_email, contact_telephone, address,
      active, no_users, no_disciplines, logo, student_email_template, supervisor_email_template);
  }

  constructor(
    public id: number,
    public organisation_name?: string,
    public business_owner_name?: string,
    public contact_email?: string,
    public contact_telephone?: string,
    public address?: string,
    public active?: boolean,
    public no_users?: number,
    public no_disciplines?: number,
    public logo?: string,
    public student_email_template?: string,
    public supervisor_email_template?: string
  ) {
  }
};

export interface IOrganisationNew {
  organisation_name?: string,
  business_owner_name?: string,
  contact_email?: string,
  contact_telephone?: string,
  address?: string,
  logo?: string,
  active: boolean,
  id?: number,
  student_email_template?: string,
  supervisor_email_template?: string
};

export class OrganisationNew implements IOrganisationNew {
  static create() {
    return new OrganisationNew();
  }
  constructor(
    public organisation_name?: string,
    public business_owner_name?: string,
    public contact_email?: string,
    public contact_telephone?: string,
    public address?: string,
    public logo?: string,
    public active = true,
    public id?: number,
    public student_email_template?: string,
    public supervisor_email_template?: string

  ) { }

};
//#endregion

//#region OrganisationDiscipline
export type OrganisationDisciplineType = OrganisationDisciplineNew | OrganisationDiscipline;

export interface IOrganisationDiscipline {
  id: number,
  organisation_id: number,
  discipline_name?: string,
  discipline_id?: number,
  active?: boolean,
  no_users?: number
};

export class OrganisationDiscipline implements IOrganisationDiscipline {
  static create(args: any) {
    const { id, organisation_id, discipline_name, discipline_id, active, no_users } = args;
    return new OrganisationDiscipline(id, organisation_id, discipline_name, discipline_id, active, no_users);
  }

  constructor(
    public id: number,
    public organisation_id: number,
    public discipline_name?: string,
    public discipline_id?: number,
    public active?: boolean,
    public no_users?: number
  ) {
  }
};

export interface IOrganisationDisciplineNew {
  organisation_id: number,
  discipline_id?: number,
  id?: number,
  discipline_name?: string
};

export class OrganisationDisciplineNew implements IOrganisationDisciplineNew {
  static create(args: any) {
    const { id } = { ...args };
    return new OrganisationDisciplineNew(id);
  }
  constructor(
    public organisation_id: number,
    public id?: number,
    public discipline_id?: number,
    public discipline_name?: string,
  ) { }

};
//#endregion

//#region OrganisationUser
export type OrganisationUserType = OrganisationUserNew | OrganisationUser;

export interface IOrganisationUser {
  id: number,
  organisation_id: number,
  user_id?: number,
  user?: string,
  email?: string,
  user_roles?: any[],
  user_roles_text?: string
};

export class OrganisationUser implements IOrganisationUser {
  static create(args: any) {
    const { id, organisation_id, user_id, user, email, user_roles, user_roles_text } = args;
    return new OrganisationUser(id, organisation_id, user_id, user, email, user_roles, user_roles_text);
  }

  constructor(
    public id: number,
    public organisation_id: number,
    public user_id?: number,
    public user?: string,
    public email?: string,
    public user_roles?: any[],
    public user_roles_text?: string
  ) {
    // this.user_roles_text = this.user_roles_text ? this.user_roles_text.replace(/\r\n?|\n/g, "<br>") : "";
  }
};

export interface IOrganisationUserNew {
  organisation_id: number,
  email?: string,
  user_id?: number,
  id?: number,
  user_roles?: any[],
  user_roles_text?: string
};

export class OrganisationUserNew implements IOrganisationUserNew {
  static create(args: any) {
    const { id } = { ...args };
    return new OrganisationUserNew(id);
  }
  constructor(
    public organisation_id: number,
    public email?: string,
    public id?: number,
    public user_id?: number,
    public user_roles?: any[],
    public user_roles_text?: string
  ) { }

};
//#endregion

//#region OrganisationDisciplineUser
export type OrganisationDisciplineUserType = OrganisationDisciplineUserNew | OrganisationDisciplineUser;

export interface IOrganisationDisciplineUser {
  id: number,
  organisation_discipline_id: number,
  user_id?: number,
  user?: string,
  email?: string,
  user_roles?: any[],
  user_roles_text?: string
};

export class OrganisationDisciplineUser implements IOrganisationDisciplineUser {
  static create(args: any) {
    const { id, organisation_discipline_id, user_id, user, email, user_roles, user_roles_text } = args;
    return new OrganisationDisciplineUser(id, organisation_discipline_id, user_id, user, email, user_roles, user_roles_text);
  }

  constructor(
    public id: number,
    public organisation_discipline_id: number,
    public user_id?: number,
    public user?: string,
    public email?: string,
    public user_roles?: any[],
    public user_roles_text?: string
  ) {
    // this.user_roles_text = this.user_roles_text ? this.user_roles_text.replace(/\r\n?|\n/g, "<br>") : "";
  }
};

export interface IOrganisationDisciplineUserNew {
  organisation_discipline_id: number,
  email?: string,
  user_id?: number,
  id?: number,
  user_roles?: any[],
  user_roles_text?: string
};

export class OrganisationDisciplineUserNew implements IOrganisationDisciplineUserNew {
  static create(args: any) {
    const { id } = { ...args };
    return new OrganisationDisciplineUserNew(id);
  }
  constructor(
    public organisation_discipline_id: number,
    public email?: string,
    public id?: number,
    public user_id?: number,
    public user_roles?: any[],
    public user_roles_text?: string
  ) { }

};
//#endregion

//#region help info
export interface IHelpInfo {
  id?: number;
  site_section?: string;
  element_name?: string;
  html?: string;
  heading?: string;
};

export class HelpInfo implements IHelpInfo {
  static create(args: any) {
    const {
      id, site_section, element_name,
      html, heading
    } = args;
    return new HelpInfo(
      id, site_section, element_name, html,
      heading
    );
  }

  constructor(
    public id?: number,
    public site_section?: string,
    public element_name?: string,
    public html?: string,
    public heading?: string
  ) {
  }
};
//#endregion

//#region Terms
export interface ITerms {
  id?: number;
  html?: string;
  version_number?: number;
  approved?: boolean;
  doc_type?: string;
};

export class Terms implements ITerms {

  static create(args: any) {
    const {
      id, html, version_number,
      approved, doc_type
    } = args;
    return new Terms(id, html, version_number,
      approved || false, doc_type);
  }

  constructor(
    public id?: number,
    public html?: string,
    public version_number?: number,
    public approved: boolean = false,
    public doc_type: string = docTypes[0].value
  ) {
    console.log('Terms:constructor: ', this);
  }

  prepareForSubmit(): any {
    return {
      html: this.html,
      version_number: this.version_number ? this.version_number++ : 1,
      doc_type: this.doc_type
    }
  }
};
//#endregion

//#region Evaluation
export type EvaluationType = EvaluationNew | Evaluation | EvaluationCopy;

export interface IEvaluation {
  id: number,
  evaluation_name?: string,
  updatedAt?: Date,
  discipline_id?: number,
  discipline_name?: string,
  updated_by_user_id?: number,
  updated_by?: string,
  active?: boolean,
  rating_scale_qty?: number,
  domain_qty?: number,
  additional_question_qty?: number,
  comment?: string,
  participant_instruction?: string,
  domain_instruction_student?: string,
  domain_instruction_supervisor?: string,
  domain_instruction_professional?: string,
};

export class Evaluation implements IEvaluation {
  static create(args: any) {
    const { id, evaluation_name, updatedAt, discipline_id, discipline_name,
      updated_by_user_id, updated_by, active, rating_scale_qty, domain_qty, additional_question_qty,
      comment, participant_instruction, domain_instruction_student, domain_instruction_supervisor, domain_instruction_professional } = args;
    return new Evaluation(id, evaluation_name, updatedAt, discipline_id, discipline_name,
      updated_by_user_id, updated_by, active, rating_scale_qty, domain_qty, additional_question_qty,
      comment, participant_instruction, domain_instruction_student, domain_instruction_supervisor, domain_instruction_professional);
  }

  constructor(
    public id: number,
    public evaluation_name?: string,
    public updatedAt?: Date,
    public discipline_id?: number,
    public discipline_name?: string,
    public updated_by_user_id?: number,
    public updated_by?: string,
    public active?: boolean,
    public rating_scale_qty?: number,
    public domain_qty?: number,
    public additional_question_qty?: number,
    public comment?: string,
    public participant_instruction?: string,
    public domain_instruction_student?: string,
    public domain_instruction_supervisor?: string,
    public domain_instruction_professional?: string
  ) { }
};

export interface IEvaluationNew {
  evaluation_name?: string,
  discipline_id?: number,
  active?: boolean,
  id?: number,
  comment?: string,
  participant_instruction?: string,
  domain_instruction_student?: string,
  domain_instruction_supervisor?: string,
  domain_instruction_professional?: string
};

export class EvaluationNew implements IEvaluationNew {
  static create() {
    return new EvaluationNew();
  }
  constructor(
    public evaluation_name?: string,
    public discipline_id?: number,
    public id?: number,
    public active = true,
    public comment?: string,
    public participant_instruction?: string,
    public domain_instruction_student?: string,
    public domain_instruction_supervisor?: string,
    public domain_instruction_professional?: string
  ) { }

};

export interface IEvaluationCopy {
  evaluation_name?: string,
  id: number,
  participant_instruction?: string
};

export class EvaluationCopy implements EvaluationCopy {
  static create(id: number) {
    return new EvaluationCopy(id);
  }

  constructor(
    public id: number,
    public evaluation_name?: string,
    public participant_instruction?: string
  ) {
  }
}
//#endregion

//#region EvaluationRatingScale
export type EvaluationRatingScaleType = EvaluationRatingScaleNew | EvaluationRatingScale;

export interface IEvaluationRatingScale {
  id: number,
  evaluation_id: number,
  rating_scale_name?: string,
  rating_scale_description?: string,
  rating_scale_value?: number,
  active?: boolean,
  evaluation_name?: string
};

export class EvaluationRatingScale implements IEvaluationRatingScale {
  static create(args: any) {
    const { id, evaluation_id, rating_scale_name, rating_scale_description, rating_scale_value, active, evaluation_name } = args;
    return new EvaluationRatingScale(id, evaluation_id, rating_scale_name, rating_scale_description, rating_scale_value, active, evaluation_name);
  }

  constructor(
    public id: number,
    public evaluation_id: number,
    public rating_scale_name?: string,
    public rating_scale_description?: string,
    public rating_scale_value?: number,
    public active?: boolean,
    public evaluation_name?: string
  ) {
  }
};

export interface IEvaluationRatingScaleNew {
  evaluation_id: number,
  rating_scale_value?: number,
  id?: number,
  rating_scale_description?: string,
  rating_scale_name?: string,
  active?: boolean
};

export class EvaluationRatingScaleNew implements IEvaluationRatingScaleNew {
  static create(args: any) {
    const { id } = { ...args };
    return new EvaluationRatingScaleNew(id);
  }
  constructor(
    public evaluation_id: number,
    public id?: number,
    public rating_scale_value?: number,
    public rating_scale_description?: string,
    public rating_scale_name?: string,
    public active = true
  ) { }

};
//#endregion

//#region EvaluationDomain
export type EvaluationDomainType = EvaluationDomainNew | EvaluationDomain;

export interface IEvaluationDomain {
  id: number,
  evaluation_id: number,
  evaluation_name?: string,
  domain_description?: string,
  self_report_instructions?: string,
  observer_report_instructions?: string,
  always_include?: boolean,
  can_opt_out?: boolean,
  active?: boolean,
  sort_order?: number,
  help_info_id?: number,
  element_name?: string,
  heading?: string,
  html?: string,
  site_section?: string,
  question_qty?: number,

};

export class EvaluationDomain implements IEvaluationDomain {
  static create(args: any) {
    const { id,
      evaluation_id,
      evaluation_name,
      domain_description,
      self_report_instructions,
      observer_report_instructions,
      always_include,
      can_opt_out,
      active,
      sort_order,
      help_info_id,
      element_name,
      heading,
      html,
      site_section,
      question_qty } = args;
    return new EvaluationDomain(id,
      evaluation_id,
      evaluation_name,
      domain_description,
      self_report_instructions,
      observer_report_instructions,
      always_include,
      can_opt_out,
      active,
      sort_order,
      help_info_id,
      element_name,
      heading,
      html,
      site_section,
      question_qty);
  }

  constructor(
    public id: number,
    public evaluation_id: number,
    public evaluation_name?: string,
    public domain_description?: string,
    public self_report_instructions?: string,
    public observer_report_instructions?: string,
    public always_include?: boolean,
    public can_opt_out?: boolean,
    public active?: boolean,
    public sort_order?: number,
    public help_info_id?: number,
    public element_name?: string,
    public heading?: string,
    public html?: string,
    public site_section?: string,
    public question_qty?: number
  ) {
  }
};

export interface IEvaluationDomainNew {
  id?: number,
  evaluation_id: number,
  evaluation_name?: string,
  domain_description?: string,
  self_report_instructions?: string,
  observer_report_instructions?: string,
  always_include?: boolean,
  can_opt_out?: boolean,
  active?: boolean,
  help_info_id?: number
};

export class EvaluationDomainNew implements IEvaluationDomainNew {
  static create(args: any) {
    const { id } = { ...args };
    return new EvaluationDomainNew(id);
  }
  constructor(
    public evaluation_id: number,
    public id?: number,
    public evaluation_name?: string,
    public domain_description?: string,
    public self_report_instructions?: string,
    public observer_report_instructions?: string,
    public always_include = true,
    public can_opt_out = false,
    public active = true,
    public help_info_id?: number
  ) { }

};
//#endregion

//#region EvaluationDomainQuestion
export type EvaluationDomainQuestionType = EvaluationDomainQuestionNew | EvaluationDomainQuestion;

export interface IEvaluationDomainQuestion {
  id: number,
  evaluation_domain_id: number,
  question?: string,
  active?: boolean,
  sort_order?: number,
  help_info_id?: number,
  element_name?: string,
  heading?: string,
  html?: string,
  site_section?: string

};

export class EvaluationDomainQuestion implements IEvaluationDomainQuestion {
  static create(args: any) {
    const { id,
      evaluation_domain_id,
      question,
      active,
      sort_order,
      help_info_id,
      element_name,
      heading,
      html,
      site_section } = args;
    return new EvaluationDomainQuestion(id,
      evaluation_domain_id,
      question,
      active,
      sort_order,
      help_info_id,
      element_name,
      heading,
      html,
      site_section);
  }

  constructor(
    public id: number,
    public evaluation_domain_id: number,
    public question?: string,
    public active?: boolean,
    public sort_order?: number,
    public help_info_id?: number,
    public element_name?: string,
    public heading?: string,
    public html?: string,
    public site_section?: string
  ) {
  }
};

export interface IEvaluationDomainQuestionNew {
  id?: number,
  evaluation_domain_id: number,
  question?: string,
  active?: boolean,
  help_info_id?: number
};

export class EvaluationDomainQuestionNew implements IEvaluationDomainQuestionNew {
  static create(args: any) {
    const { id } = { ...args };
    return new EvaluationDomainQuestionNew(id);
  }
  constructor(
    public evaluation_domain_id: number,
    public id?: number,
    public question?: string,
    public active = true,
    public help_info_id?: number
  ) { }

};
//#endregion

//#region EvaluationAdditionalQuestion
export type EvaluationAdditionalQuestionType = EvaluationAdditionalQuestionNew | EvaluationAdditionalQuestion;

export interface IEvaluationAdditionalQuestion {
  id: number,
  evaluation_id: number,
  question?: string,
  response_type?: string,
  decimal_places?: number,
  options?: object,
  compulsory?: boolean,
  supervisor_applicable?: boolean,
  supervisee_applicable?: boolean,
  professional_applicable?: boolean,
  active?: boolean,
  sort_order?: number,
  help_info_id?: number
};


export class EvaluationAdditionalQuestion implements IEvaluationAdditionalQuestion {
  static create(args: any) {
    const {
      id,
      evaluation_id,
      question,
      response_type,
      decimal_places,
      options,
      compulsory,
      supervisor_applicable,
      supervisee_applicable,
      professional_applicable,
      active,
      sort_order,
      help_info_id
    } = args;
    return new EvaluationAdditionalQuestion(
      id,
      evaluation_id,
      question,
      response_type,
      decimal_places,
      options,
      compulsory,
      supervisor_applicable,
      supervisee_applicable,
      professional_applicable,
      active,
      sort_order,
      help_info_id
    );
  }

  constructor(
    public id: number,
    public evaluation_id: number,
    public question?: string,
    public response_type?: string,
    public decimal_places?: number,
    public options?: object,
    public compulsory?: boolean,
    public supervisor_applicable?: boolean,
    public supervisee_applicable?: boolean,
    public professional_applicable?: boolean,
    public active?: boolean,
    public sort_order?: number,
    public help_info_id?: number
  ) { }

  get isCompulsory(): string {
    return this.compulsory ? 'Yes' : '';
  }
  get isSupervisor(): string {
    return this.supervisor_applicable ? 'Yes' : '';
  }
  get isSupervisee(): string {
    return this.supervisee_applicable ? 'Yes' : '';
  }
  get isProfessional(): string {
    return this.professional_applicable ? 'Yes' : '';
  }

};

export interface IEvaluationAdditionalQuestionNew {
  evaluation_id: number,
  id?: number,
  question?: string,
  response_type?: string,
  decimal_places?: number,
  options?: object,
  compulsory?: boolean,
  supervisor_applicable?: boolean,
  supervisee_applicable?: boolean,
  professional_applicable?: boolean,
  active?: boolean,
  help_info_id?: number
};

export class EvaluationAdditionalQuestionNew implements IEvaluationAdditionalQuestionNew {
  static create(args: any) {
    const { id } = { ...args };
    return new EvaluationAdditionalQuestionNew(id);
  }
  constructor(
    public evaluation_id: number,
    public id?: number,
    public question?: string,
    public response_type = "Text",
    public decimal_places?: number,
    public options?: object,
    public compulsory = true,
    public supervisor_applicable = true,
    public supervisee_applicable?: boolean,
    public professional_applicable?: boolean,
    public active = true,
    public help_info_id?: number
  ) { }

};
//#endregion

//#region question option
export interface IQuestionOption {
  sort_order?: number,
  option?: string
};

export class QuestionOption implements IQuestionOption {
  static create(args: any) {
    const { sort_order, option } = args;
    return new QuestionOption(sort_order, option);
  }

  constructor(
    public sort_order?: number,
    public option?: string
  ) { }

};
//#endregion

//#region PlacementReview
export type PlacementReviewType = PlacementReviewNew | PlacementReview;

export interface IPlacementReview {
  id: number,
  organisation_id?: number,
  organisation_name?: string,
  discipline_id?: number,
  discipline_name?: string,
  evaluation_id?: number,
  evaluation_name?: string,
  unit_of_study?: string,
  client_contact_target_hours?: number,
  individual_supervision_target_hours?: number,
  group_supervision_target_hours?: number,
  other_activities_target_hours?: number,
  total_target_hours?: number,
  updated_by_user_id?: number,
  updated_by?: string,
  updatedAt?: Date,
  active?: boolean,
  no_student?: number,
  domain_count?: string
};

export class PlacementReview implements IPlacementReview {
  static create(args: any) {
    const { id, organisation_id, organisation_name, discipline_id, discipline_name, evaluation_id, evaluation_name,
      unit_of_study, client_contact_target_hours, individual_supervision_target_hours, group_supervision_target_hours,
      other_activities_target_hours, total_target_hours, updated_by_user_id, updated_by, updatedAt, active, no_student, domain_count } = args;
    return new PlacementReview(id, organisation_id, organisation_name, discipline_id, discipline_name, evaluation_id, evaluation_name,
      unit_of_study, client_contact_target_hours, individual_supervision_target_hours, group_supervision_target_hours,
      other_activities_target_hours, total_target_hours, updated_by_user_id, updated_by, updatedAt, active, no_student, domain_count);
  }

  constructor(
    public id: number,
    public organisation_id?: number,
    public organisation_name?: string,
    public discipline_id?: number,
    public discipline_name?: string,
    public evaluation_id?: number,
    public evaluation_name?: string,
    public unit_of_study?: string,
    public client_contact_target_hours?: number,
    public individual_supervision_target_hours?: number,
    public group_supervision_target_hours?: number,
    public other_activities_target_hours?: number,
    public total_target_hours?: number,
    public updated_by_user_id?: number,
    public updated_by?: string,
    public updatedAt?: Date,
    public active?: boolean,
    public no_student?: number,
    public domain_count?: string
  ) { }
};

export interface IPlacementReviewNew {
  id?: number,
  organisation_id?: number,
  discipline_id?: number,
  evaluation_id?: number,
  unit_of_study?: string,
  client_contact_target_hours?: number,
  individual_supervision_target_hours?: number,
  group_supervision_target_hours?: number,
  other_activities_target_hours?: number,
  total_target_hours?: number,
  active?: boolean
};

export class PlacementReviewNew implements IPlacementReviewNew {
  static create() {
    return new PlacementReviewNew();
  }
  constructor(
    public id?: number,
    public organisation_id?: number,
    public discipline_id?: number,
    public evaluation_id?: number,
    public unit_of_study?: string,
    public client_contact_target_hours?: number,
    public individual_supervision_target_hours?: number,
    public group_supervision_target_hours?: number,
    public other_activities_target_hours?: number,
    public total_target_hours?: number,
    public active = true
  ) { }

};

//#endregion

//#region PlacementReviewStudent
export type PlacementReviewStudentType = PlacementReviewStudentNew | PlacementReviewStudent;

/**
 *  "id": 40,
    "placement_review_id": 8,
    "student_user_id": 2,
    "student": "Fookes (jjcjljj), Julie(jjcjljj@gmail.com)",
    "student_institution_id": "1234567",
    "supervisor_user_id": -9,
    "supervisor": "Fookes, Julie(jfookes@une.edu.au)",
    "additional_supervisor_user_id": null,
    "additional_supervisor": null,
    "placement_location": "Placement Location - Pharm",
    "placement_start_date": "2026-06-01",
    "placement_end_date": "2026-06-30",
    "active": true,
    "unit_of_study": "Unit of Study - 2nd Placement Review",
    "organisation": "Test Organisation",
    "student_start_assessment_id": null,
    "student_assessment_start_status": "Ready to start",
    "student_mid_assessment_id": null,
    "student_assessment_mid_status": "Unavailable",
    "student_end_assessment_id": null,
    "student_assessment_end_status": "Unavailable",
    "supervisor_mid_assessment_id": null,
    "supervisor_assessment_mid_status": "Unavailable",
    "supervisor_end_assessment_id": null,
    "supervisor_assessment_end_status": "Unavailable",
    "student_email": "jjcjljj@gmail.com",
    "year_first_practice": null,
    "supervisor_last_name": "Fookes",
    "supervisor_first_name": "Julie",
    "supervisor_email": "jfookes@une.edu.au",
    "additional_supervisor_last_name": null,
    "additional_supervisor_first_name": null,
    "additional_supervisor_email": null
 */
export interface IPlacementReviewStudent {
  id: number;
  placement_review_id?: number;
  student_user_id?: number;
  student_email?: string;
  student_email_found?: boolean;
  student_first_name?: string;
  student_last_name?: string;
  student?: string;
  student_institution_id?: number;
  supervisor_user_id?: number;
  supervisor?: string;
  supervisor_first_name?: string;
  supervisor_last_name?: string;
  supervisor_email?: string;
  supervisor_email_found?: boolean;
  additional_supervisor_user_id?: number;
  additional_supervisor?: string;
  additional_supervisor_first_name?: string;
  additional_supervisor_last_name?: string;
  additional_supervisor_email?: string;
  additional_supervisor_email_found?: boolean;
  placement_location?: string;
  placement_start_date?: Date;
  placement_end_date?: Date;
  active?: boolean;
  unit_of_study?: string;
  organisation?: string;
  student_start_assessment_id?: number;
  student_assessment_start_status?: string;
  student_mid_assessment_id?: number;
  student_assessment_mid_status?: string;
  student_end_assessment_id?: number;
  student_assessment_end_status?: string;
  supervisor_mid_assessment_id?: number;
  supervisor_assessment_mid_status?: string;
  supervisor_end_assessment_id?: number;
  supervisor_assessment_end_status?: string;
  can_edit?: boolean;

  student_assessment_start_report?: boolean;
  student_assessment_mid_report?: boolean;
  student_assessment_end_report?: boolean;
  supervisor_assessment_mid_report?: boolean;
  supervisor_assessment_end_report?: boolean;
  year_first_practice?: number;

  display_supervisor_mid_review_visible?: boolean;
  supervisor_mid_review_visible?: boolean;
  display_supervisor_end_review_visible?: boolean;
  supervisor_end_review_visible?: boolean;
  student_assessment_start_can_view?: boolean;
  student_assessment_mid_can_view?: boolean;
  student_assessment_end_can_view?: boolean;
  supervisor_assessment_mid_can_view?: boolean;
  supervisor_assessment_end_can_view?: boolean;
};

export class PlacementReviewStudent implements IPlacementReviewStudent {
  public student_email_found?: boolean = false;
  public supervisor_email_found?: boolean = false;
  public additional_supervisor_email_found?: boolean = false;

  static create(args: any) {
    const { id, placement_review_id, student_user_id,
      student_email, student_first_name, student_last_name, student,
      student_institution_id, supervisor_user_id, supervisor, additional_supervisor_user_id, additional_supervisor,
      placement_location, placement_start_date, placement_end_date, active, unit_of_study, organisation,
      student_start_assessment_id, student_assessment_start_status, student_mid_assessment_id,
      student_assessment_mid_status, student_end_assessment_id, student_assessment_end_status,
      supervisor_mid_assessment_id, supervisor_assessment_mid_status, supervisor_end_assessment_id,
      supervisor_assessment_end_status, can_edit, student_assessment_start_report, student_assessment_mid_report,
      student_assessment_end_report, supervisor_assessment_mid_report, supervisor_assessment_end_report,
      year_first_practice,
      display_supervisor_mid_review_visible, supervisor_mid_review_visible,
      display_supervisor_end_review_visible, supervisor_end_review_visible,
      student_assessment_start_can_view,
      student_assessment_mid_can_view,
      student_assessment_end_can_view,
      supervisor_assessment_mid_can_view,
      supervisor_assessment_end_can_view,
      supervisor_email, supervisor_first_name, supervisor_last_name,
      additional_supervisor_email, additional_supervisor_first_name, additional_supervisor_last_name
    } = args;

    return new PlacementReviewStudent(id, placement_review_id, student_user_id,
      student_email, student_first_name, student_last_name, student,
      student_institution_id, supervisor_user_id, supervisor, additional_supervisor_user_id, additional_supervisor,
      placement_location, placement_start_date, placement_end_date, active, unit_of_study, organisation,
      student_start_assessment_id, student_assessment_start_status, student_mid_assessment_id,
      student_assessment_mid_status, student_end_assessment_id, student_assessment_end_status,
      supervisor_mid_assessment_id, supervisor_assessment_mid_status, supervisor_end_assessment_id,
      supervisor_assessment_end_status, can_edit, student_assessment_start_report, student_assessment_mid_report,
      student_assessment_end_report, supervisor_assessment_mid_report, supervisor_assessment_end_report,
      year_first_practice,
      display_supervisor_mid_review_visible, supervisor_mid_review_visible,
      display_supervisor_end_review_visible, supervisor_end_review_visible,
      student_assessment_start_can_view,
      student_assessment_mid_can_view,
      student_assessment_end_can_view,
      supervisor_assessment_mid_can_view,
      supervisor_assessment_end_can_view,
      supervisor_email, supervisor_first_name, supervisor_last_name,
      additional_supervisor_email, additional_supervisor_first_name, additional_supervisor_last_name
    );
  }

  constructor(
    public id: number,
    public placement_review_id?: number,
    public student_user_id?: number,
    public student_email?: string,
    public student_last_name?: string,
    public student_first_name?: string,
    public student?: string,
    public student_institution_id?: number,
    public supervisor_user_id?: number,
    public supervisor?: string,
    public additional_supervisor_user_id?: number,
    public additional_supervisor?: string,
    public placement_location?: string,
    public placement_start_date?: Date,
    public placement_end_date?: Date,
    public active?: boolean,
    public unit_of_study?: string,
    public organisation?: string,
    public student_start_assessment_id?: number,
    public student_assessment_start_status?: string,
    public student_mid_assessment_id?: number,
    public student_assessment_mid_status?: string,
    public student_end_assessment_id?: number,
    public student_assessment_end_status?: string,
    public supervisor_mid_assessment_id?: number,
    public supervisor_assessment_mid_status?: string,
    public supervisor_end_assessment_id?: number,
    public supervisor_assessment_end_status?: string,
    public can_edit?: boolean,
    public student_assessment_start_report?: boolean,
    public student_assessment_mid_report?: boolean,
    public student_assessment_end_report?: boolean,
    public supervisor_assessment_mid_report?: boolean,
    public supervisor_assessment_end_report?: boolean,
    public year_first_practice?: number,
    public display_supervisor_mid_review_visible?: boolean,
    public supervisor_mid_review_visible?: boolean,
    public display_supervisor_end_review_visible?: boolean,
    public supervisor_end_review_visible?: boolean,
    public student_assessment_start_can_view?: boolean,
    public student_assessment_mid_can_view?: boolean,
    public student_assessment_end_can_view?: boolean,
    public supervisor_assessment_mid_can_view?: boolean,
    public supervisor_assessment_end_can_view?: boolean,
    public supervisor_email?: string,
    public supervisor_first_name?: string,
    public supervisor_last_name?: string,
    public additional_supervisor_email?: string,
    public additional_supervisor_first_name?: string,
    public additional_supervisor_last_name?: string
  ) {
    if(this.student_email){
      this.student_email_found = true;
    }
    if (this.supervisor_email) {
      this.supervisor_email_found = true;
    }
    if (this.additional_supervisor_email) {
      this.additional_supervisor_email_found = true;
    }
  }
  getAssessmentId(fieldName: keyof PlacementReviewStudent): any {
    return this[fieldName] ?? null;
  }

  isToPrint(field: string): boolean {
    const reportMap: Record<string, keyof PlacementReviewStudent> = {
      student_assessment_start_status: 'student_assessment_start_report',
      student_assessment_mid_status: 'student_assessment_mid_report',
      student_assessment_end_status: 'student_assessment_end_report',
      supervisor_assessment_mid_status: 'supervisor_assessment_mid_report',
      supervisor_assessment_end_status: 'supervisor_assessment_end_report'
    };
    const reportField = reportMap[field];
    return reportField ? !!this[reportField] : false;
  }

};

export interface IPlacementReviewStudentNew {
  placement_review_id: number;
  id?: number;
  student_email?: string;
  student_first_name?: string;
  student_last_name?: string;
  student_institution_id?: number;
  active?: boolean;
  student_email_found?: boolean;
  supervisor_email_found?: boolean;
  additional_supervisor_email_found?: boolean;
  additional_supervisor_email?: string;
};

export class PlacementReviewStudentNew implements IPlacementReviewStudentNew {
  public student_email_found?: boolean = false;
  public supervisor_email_found?: boolean = false;
  public additional_supervisor_email_found?: boolean = false;
  public additional_supervisor_email?: string | undefined;

  static create(args: any) {
    const { id } = { ...args };
    return new PlacementReviewStudentNew(id);
  }
  constructor(
    public placement_review_id: number,
    public id?: number,
    public student_email?: string,
    public student_first_name?: string,
    public student_last_name?: string,
    public student_institution_id?: number,
    public active = true
  ) { }

};

export interface ICasiDateRange {
  start: any;
  end: any;
};
export class CasiDateRange implements ICasiDateRange {
  /**
   * Assumes that the start and date are valid date strings.
   *
   * @param start
   * @param end
   * @returns
   */
  static create(start?: string, end?: string) {
    if (start && end) {
      return new CasiDateRange(new Date(start), new Date(end));
    } else if (start && !end) {
      return new CasiDateRange(new Date(start), null);
    } else if (!start && end) {
      return new CasiDateRange(null, new Date(end));
    } else {
      return new CasiDateRange(null, null);
    }
  }
  constructor(
    public start: any,
    public end: any
  ) { }
};
//#endregion

//#region PlacementReviewDomain
export type PlacementReviewDomainType = PlacementReviewDomainNew | PlacementReviewDomain;

export interface IPlacementReviewDomain {
  id: number,
  placement_review_id?: number,
  evaluation_domain_id?: number,
  domain_description?: string,
  self_report_instructions?: string,
  observer_report_instructions?: string,
  always_include?: boolean,
  can_opt_out?: boolean,
  help_info_id?: number,
  sort_order?: number,
  active?: boolean,
  included?: boolean
};

export class PlacementReviewDomain implements IPlacementReviewDomain {
  static create(args: any) {
    const { id, placement_review_id, evaluation_domain_id, domain_description, self_report_instructions,
      observer_report_instructions, always_include, can_opt_out, help_info_id, sort_order, active, included } = args;
    return new PlacementReviewDomain(id, placement_review_id, evaluation_domain_id, domain_description, self_report_instructions,
      observer_report_instructions, always_include, can_opt_out, help_info_id, sort_order, active, included);
  }

  constructor(
    public id: number,
    public placement_review_id?: number,
    public evaluation_domain_id?: number,
    public domain_description?: string,
    public self_report_instructions?: string,
    public observer_report_instructions?: string,
    public always_include?: boolean,
    public can_opt_out?: boolean,
    public help_info_id?: number,
    public sort_order?: number,
    public active?: boolean,
    public included?: boolean
  ) { }
};

export interface IPlacementReviewDomainNew {
  placement_review_id: number,
  id?: number,
  evaluation_domain_id?: number,
  domain_description?: string,
  self_report_instructions?: string,
  observer_report_instructions?: string,
  always_include?: boolean,
  can_opt_out?: boolean,
  help_info_id?: number,
  sort_order?: number,
  active?: boolean,
  included?: boolean
};

export class PlacementReviewDomainNew implements IPlacementReviewDomainNew {
  static create(args: any) {
    const { id } = { ...args };
    return new PlacementReviewDomainNew(id);
  }
  constructor(
    public placement_review_id: number,
    public id?: number,
    public evaluation_domain_id?: number,
    public domain_description?: string,
    public self_report_instructions?: string,
    public observer_report_instructions?: string,
    public always_include?: boolean,
    public can_opt_out?: boolean,
    public help_info_id?: number,
    public sort_order?: number,
    public included?: boolean,
    public active = true
  ) { }

};

//#endregion

//#region AssessmentDomainAnswer

export interface IAssessmentDomainAnswer {
  assessment_domain_answer_id: number,
  evaluation_domain_question_id?: number,
  value?: number,
  question?: string,
  sort_order?: number,
  help_info_id?: number
};

export class AssessmentDomainAnswer implements IAssessmentDomainAnswer {
  static create(args: any) {
    const { assessment_domain_answer_id, evaluation_domain_question_id, value, question, sort_order, help_info_id } = args;
    return new AssessmentDomain(assessment_domain_answer_id, evaluation_domain_question_id, value, question, sort_order, help_info_id);
  }

  constructor(
    public assessment_domain_answer_id: number,
    public evaluation_domain_question_id?: number,
    public value?: number,
    public question?: string,
    public sort_order?: number,
    public help_info_id?: number
  ) { }
};
//#endregion


//#region AssessmentDomain

export interface IAssessmentDomain {
  assessment_domain_id: number,
  evaluation_domain_id?: number,
  opt_out?: boolean,
  comment?: string,
  domain_description?: string,
  self_report_instructions?: string,
  observer_report_instructions?: string,
  always_include?: boolean,
  can_opt_out?: boolean,
  sort_order?: number,
  help_info_id?: number,
  domain_answers?: AssessmentDomainAnswer[],
  domain_instruction?: string
};

export class AssessmentDomain implements IAssessmentDomain {
  static create(args: any) {
    const { assessment_domain_id, evaluation_domain_id, opt_out, comment, domain_description, self_report_instructions,
      observer_report_instructions, always_include, can_opt_out, sort_order, help_info_id, domain_answers, domain_instruction } = args;
    return new AssessmentDomain(assessment_domain_id, evaluation_domain_id, opt_out, comment, domain_description, self_report_instructions,
      observer_report_instructions, always_include, can_opt_out, sort_order, help_info_id, domain_answers, domain_instruction);
  }

  constructor(
    public assessment_domain_id: number,
    public evaluation_domain_id?: number,
    public opt_out?: boolean,
    public comment?: string,
    public domain_description?: string,
    public self_report_instructions?: string,
    public observer_report_instructions?: string,
    public always_include?: boolean,
    public can_opt_out?: boolean,
    public sort_order?: number,
    public help_info_id?: number,
    public domain_answers?: AssessmentDomainAnswer[],
    public domain_instruction?: string
  ) { }
};
//#endregion

//#region AdditionalQuestionOption

export interface IAdditionalQuestionOption {
  option?: string,
  sort_order?: number
};

export class AdditionalQuestionOption implements IAdditionalQuestionOption {
  static create(args: any) {
    const { option, sort_order } = args;
    return new AdditionalQuestionOption(option, sort_order);
  }

  constructor(
    public option?: string,
    public sort_order?: number
  ) { }
};
//#endregion


//#region AssessmentAdditionalQuestion

export interface IAssessmentAdditionalQuestion {
  assessment_additional_answer_id: number,
  value?: string,
  question?: string,
  response_type?: string,
  decimal_places?: number,
  options?: AdditionalQuestionOption[],
  compulsory?: boolean,
  supervisor_applicable?: boolean,
  supervisee_applicable?: boolean,
  professional_applicable?: boolean,
  sort_order?: number,
  help_info_id?: number,
  evaluation_additional_question_id?: number
};

export class AssessmentAdditionalQuestion implements IAssessmentAdditionalQuestion {
  static create(args: any) {
    const { assessment_additional_answer_id, value, question, response_type, decimal_places, options, compulsory,
      supervisor_applicable, supervisee_applicable, professional_applicable, sort_order, help_info_id, evaluation_additional_question_id } = args;
    return new AssessmentAdditionalQuestion(assessment_additional_answer_id, value, question, response_type, decimal_places, options, compulsory,
      supervisor_applicable, supervisee_applicable, professional_applicable, sort_order, help_info_id, evaluation_additional_question_id);
  }

  constructor(
    public assessment_additional_answer_id: number,
    public value?: string,
    public question?: string,
    public response_type?: string,
    public decimal_places?: number,
    public options?: AdditionalQuestionOption[],
    public compulsory?: boolean,
    public supervisor_applicable?: boolean,
    public supervisee_applicable?: boolean,
    public professional_applicable?: boolean,
    public sort_order?: number,
    public help_info_id?: number,
    public evaluation_additional_question_id?: number
  ) { }
};
//#endregion

//#region AssessmentRatingScale

export interface IAssessmentRatingScale {
  rating_scale_name?: string,
  rating_scale_description?: string,
  rating_scale_value?: number
};

export class AssessmentRatingScale implements IAssessmentRatingScale {
  static create(args: any) {
    const { rating_scale_name, rating_scale_description, rating_scale_value } = args;
    return new AssessmentRatingScale(rating_scale_name, rating_scale_description, rating_scale_value);
  }

  constructor(
    public rating_scale_name?: string,
    public rating_scale_description?: string,
    public rating_scale_value?: number
  ) { }
};
//#endregion

//#region Assessment

export interface IAssessment {
  id?: number;
  respondent_user_id?: number;
  evaluation_id?: number;
  placement_review_student_id?: number;
  completed?: boolean;
  comment?: string;
  participant_instruction?: string;
  domain_instruction?: string;
  client_contact_target_hours?: number;
  client_contact_hours?: number;
  individual_supervision_target_hours?: number;
  individual_supervision_hours?: number;
  group_supervision_target_hours?: number;
  group_supervision_hours?: number;
  other_activities_target_hours?: number;
  other_activities_hours?: number;
  total_target_hours?: number;
  domains?: AssessmentDomain[];
  additional_answers?: AssessmentAdditionalQuestion[];
  rating_scale?: AssessmentRatingScale[];
  introduction_heading?: string;
};

export class Assessment implements IAssessment {
  static create(args: any) {
    const { id, respondent_user_id, evaluation_id, placement_review_student_id, completed, comment, participant_instruction, domain_instruction,
      client_contact_target_hours, client_contact_hours, individual_supervision_target_hours, individual_supervision_hours,
      group_supervision_target_hours, group_supervision_hours, other_activities_target_hours, total_target_hours, domains, additional_answers,
      other_activities_hours, rating_scale, introduction_heading } = args;
    return new Assessment(id, respondent_user_id, evaluation_id, placement_review_student_id, completed, comment, participant_instruction, domain_instruction,
      client_contact_target_hours, client_contact_hours, individual_supervision_target_hours, individual_supervision_hours,
      group_supervision_target_hours, group_supervision_hours, other_activities_target_hours, other_activities_hours, total_target_hours, domains, additional_answers,
      rating_scale, introduction_heading || "Competencies of Professional Psychology Rating Scale (CROPPRs)");
  }

  constructor(
    public id?: number,
    public respondent_user_id?: number,
    public evaluation_id?: number,
    public placement_review_student_id?: number,
    public completed?: boolean,
    public comment?: string,
    public participant_instruction?: string,
    public domain_instruction?: string,
    public client_contact_target_hours?: number,
    public client_contact_hours?: number,
    public individual_supervision_target_hours?: number,
    public individual_supervision_hours?: number,
    public group_supervision_target_hours?: number,
    public group_supervision_hours?: number,
    public other_activities_target_hours?: number,
    public other_activities_hours?: number,
    public total_target_hours?: number,
    public domains?: AssessmentDomain[],
    public additional_answers?: AssessmentAdditionalQuestion[],
    public rating_scale?: AssessmentRatingScale[],
    public introduction_heading?: string
  ) { }


};

//#endregion

//#region unit of study
export interface IUnitOfStudy {
  id?: number;
  unit_of_study?: string;
  organisation_id?: number;
  evaluation_id?: number;
};

export class IUnitOfStudy implements IUnitOfStudy {
  static create(args: any) {
    const { id, unit_of_study, organisation_id, evaluation_id } = args;
    return new IUnitOfStudy(id, unit_of_study, organisation_id, evaluation_id);
  }

  constructor(
    public id?: number,
    public unit_of_study?: string,
    public organisation_id?: number,
    public evaluation_id?: number
  ) {
  }
};
//#endregion

interface Header {
  heading: string;
  order_no: number;
  field_name: string;
}

export interface IGridResponse {
  header?: Header[];
  body?: Array<Array<Record<string, any>>>; //Record<string, any>[];
}

export class GridResponse implements IGridResponse {
  static create(args: any) {
    const { header, body } = { ...args };
    return new GridResponse(header, body);
  }

  constructor(
    public header?: Header[],
    public body?: Array<Array<Record<string, any>>>//Record<string, any>[]
  ) {
  }
};

//#region Env Variables

export interface IEnvVars {
  testFlag?: boolean;
}

export class EnvVars implements IEnvVars {
  static create(args: any) {
    const { testFlag } = args;
    return new EnvVars(testFlag);
  }
  constructor(
    public testFlag?: boolean
  ) { }
}

//#endregion
